import { render, staticRenderFns } from "./investor.vue?vue&type=template&id=67449fbc&scoped=true&"
import script from "./investor.vue?vue&type=script&lang=js&"
export * from "./investor.vue?vue&type=script&lang=js&"
import style0 from "./investor.vue?vue&type=style&index=0&id=67449fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67449fbc",
  null
  
)

export default component.exports